/**
 * Клиент Sentry.
 */
export const Raven = window.Raven || {
  captureException: process.env.HOSTNAME !== 'development_host' ? window.console.error : () => {},
}
